<template lang="pug">
.d-flex
  .flex-grow-1
    filter-date-range.mr-2(ref="date" :dates.sync="datesFilter" initializeDate)
    filter-time-range.mr-2(ref="timeRange" :filter.sync="timeRangeFilter")
    filter-panel-payment-method.mr-2(:filter.sync="panelFilter" filterKey="payment_ref_ids" title="Panel")
  v-btn.button-sm.underline.px-0(text :disabled="allFilters.length === 0" @click="resetFilters") Reset filters
</template>

<script>
import FilterDateRange from '@/components/clinic/reports/filters/FilterDateRange.vue'
import FilterTimeRange from '@/components/clinic/reports/filters/FilterTimeRange.vue'
import FilterPanelPaymentMethod from '@/components/clinic/reports/filters/FilterPanelPaymentMethod.vue'

export default {
  components: { FilterDateRange, FilterTimeRange, FilterPanelPaymentMethod },
  props: ['filters'],
  data: () => ({
    datesFilter: [],
    timeRangeFilter: {},
    panelFilter: {}
  }),
  watch: {
    allFilters (newValue) {
      this.$emit('update:filters', newValue)
    }
  },
  computed: {
    allFilters () {
      const filters = []
      if (this.datesFilter.length > 0) {
        filters.push({ key: 'date__gte', value: this.datesFilter[0] })
        filters.push({ key: 'date__lte', value: this.datesFilter[1] })
      }
      if (this.timeRangeFilter.key) {
        filters.push(this.timeRangeFilter)
      }
      if (this.panelFilter.key) {
        filters.push(this.panelFilter)
      }
      return filters
    }
  },
  methods: {
    resetFilters () {
      this.timeRangeFilter = {}
      this.panelFilter = {}
      this.datesFilter = []
      this.$refs.date.clear()
      this.$refs.timeRange.clear()
    }
  }
}
</script>
